/* eslint-disable import/prefer-default-export */
export const LABELS = {
  EMAIL_VERIFIED: "You're verified",
  MOVE_BACK:
    'Login to complete your application and use your profile anywhere you see the Sorted logo',
  LINK_EXPIRED: 'This link has expired.',
  GO_TO_LOGIN: 'Please go to login and click Resend Link to receive a new confirmation email',
  BUTTON_TEXT: 'Login',
};
